import type { Middleware } from '@tallerya/api-client';
import { cacheDatos } from '../datos/ProveedorDatos';

// Cómo se entera el admin, ya abierto, de que suspendieron el taller (#244).
//
// Los permisos se guardan cinco minutos y la `Guardia` no se vuelve a montar al
// pasar de una pantalla a otra, así que sin esto el dueño seguiría navegando
// entre los errores sueltos de cada pantalla. Cualquier respuesta con este código
// invalida los permisos: al volver a pedirlos fallan igual, y la guardia cambia
// la pantalla por el aviso. La vuelta, al reactivarlo, la hace `usePermisos`.

/// El código del 403 que la API devuelve a un taller suspendido (#148).
export const TALLER_SUSPENDIDO = 'auth.tenant_suspended';

/// La raíz de la clave de caché de los permisos, la de `clave` en `usePermiso.ts`.
export const RAIZ_PERMISOS = 'permisos';

export const vigilarSuspension: Middleware = {
  async onResponse({ request, response }) {
    if (response.status !== 403) return undefined;

    // La de los permisos no: si se invalidara a sí misma, se pediría sin fin.
    if (new URL(request.url).pathname.endsWith('/api/me/permissions')) return undefined;

    let codigo: unknown;
    try {
      codigo = ((await response.clone().json()) as { code?: unknown }).code;
    } catch {
      // Un 403 sin cuerpo JSON no es este caso.
      return undefined;
    }

    if (codigo === TALLER_SUSPENDIDO) {
      // Sin cortar la consulta que ya va en camino: una ficha que pide tres cosas
      // recibe tres 403, y basta con una consulta de permisos.
      void cacheDatos.invalidateQueries({ queryKey: [RAIZ_PERMISOS] }, { cancelRefetch: false });
    }

    return undefined;
  },
};
